exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-cover[data-v-6ef34c00]{min-height:136px!important;width:100%;border-bottom:2px solid;border-color:rgba(117,148,127,.24);color:#f8f8f8;position:relative}.profile-avatar img[data-v-6ef34c00]{width:136px!important;height:inherit!important}.humtog_prf[data-v-6ef34c00]{display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ef34c00","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/UserHeader.vue
// module id = 2DVo
// module chunks = 0